module.exports = __webpack_public_path__ + "img/favicon.b20c0ef.png";